import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'profile.image.alt.attribute': {
    id: 'profile.image.alt.attribute',
    defaultMessage: 'profile avatar',
    description: 'Alt attribute for a profile photo',
  },
  'profile.profileavatar.change-button': {
    id: 'profile.profileavatar.change-button',
    defaultMessage: 'Change',
    description: 'Change photo button',
  },
  'profile.profileavatar.tooltip.edit': {
    id: 'profile.profileavatar.tooltip.edit',
    defaultMessage: 'Edit photo',
    description: 'Tooltip for edit photo button',
  },
  'profile.profileavatar.tooltip.upload': {
    id: 'profile.profileavatar.tooltip.upload',
    defaultMessage: 'Upload photo',
    description: 'Tooltip for upload photo button',
  },
});

export default messages;
